export const ASK_USER_DATA_PATH = "ask-user-data";
